<div [formGroup]="tinymceForm">
  <editor 
  formControlName="tinymce" 
  initialValue="{{ tinymceData }}" 
  [(ngModel)]="tinymceData" 
  [init]="{
		plugins: 'advlist autolink lists link image charmap 
         anchor textcolor searchreplace visualblocks code fullscreen 
         insertdatetime media table help wordcount',
         menubar: false,
         branding: false,
         browser_spellcheck: true,
         spellcheck: true,
         contextmenu: false,
         toolbar1:'formatselect | fontselect | fontsizeselect | link unlink | code fullscreen',
         toolbar2:'forecolor bold italic underline strikethrough | bullist numlist blockquote | alignleft aligncenter alignright',
         resize: 'true',
         min_width: 400,
         height : '250',
         placeholder: placeholder,
         autoresize_on_init: false,
         autoresize_min_height: 150,
         autoresize_max_height: 400,
         autoresize_bottom_margin: 5,
         content_css : '/servicedesk/style/tinymce.css',
         language:curLang
    }"
  ></editor>
</div>
<div *ngIf="required && !tinymceForm.valid && tinymceForm.controls['tinymce'].touched" class="validation-error-inline text-danger">
    {{ requiredError }}
  </div>

<!-- Toolbar which changed to make editor similar to Old portal -->
<!-- This is default Toolbar for TinyMCE 4 -->
<!-- Not removing in case Older need to be removed -->
<!-- toolbar:'table code | undo redo | bold italic underline strikethrough | print link image| 
    alignleft aligncenter alignright |bullist numlist outdent |indent save', 
    -->